import debounce from "lodash/debounce";
import { useEffect, useMemo, useState } from "react";

export function useDebouncedValue<T>(value: T, delayMs: number): T {
	const [debouncedValue, setDebouncedValue] = useState(value);

	const debouncedSetValue = useMemo(() => debounce((next: T) => setDebouncedValue(next), delayMs), [delayMs]);

	useEffect(() => {
		debouncedSetValue(value);
		return () => {
			debouncedSetValue.cancel();
		};
	}, [debouncedSetValue, value]);

	return debouncedValue;
}
